// For registering new standalone (non-extended) exam experiments
export const allowedExamsExperiments = [
  // 'EXAM_WORD_RECOGNITION'
]
export const examsNameMapExperiments = {
  // EXAM_WORD_RECOGNITION: 'word-recognition'
}
export const modulesExperiments = [
  // 'word_recognition'
]

// Maps /#!/task/<id> links from mTurk to the correct experiment and base exam
export const experimentsMap = [
  {
    path: 'flanker',
    code: '32bd468e-516a-11ec-bf63-0242ac130008',
    exam: 'flanker'
  },
  {
    path: 'flanker-video',
    code: '32bd468e-516a-11ec-bf63-0242ac130003',
    exam: 'flanker'
  },
  {
    path: 'flanker-video-red-green',
    code: '32bd468e-516a-11ec-bf63-0242ac130012',
    exam: 'flanker'
  },
  {
    path: 'flanker-video-red-green-timer',
    code: '32bd468e-516a-11ec-bf63-0242ac130013',
    exam: 'flanker'
  },
  {
    path: 'flanker-video-red-green-forced-timer',
    code: '32bd468e-516a-11ec-bf63-0242ac130014',
    exam: 'flanker'
  },
  {
    path: 'image-pairs',
    code: '32bd468e-516a-11ec-bf63-0242ac130005',
    exam: 'image-pairs',
    videoPerceptions: true
  },
  {
    path: 'trails-responsive',
    code: '32bd468e-516a-11ec-bf63-0242ac130009',
    exam: 'trails'
  },
  {
    path: 'processing-speed-mouse',
    code: '32bd468e-516a-11ec-bf63-0242ac130015',
    exam: 'processing-speed'
  }
  // {
  //   path: 'trails-pink',
  //   code: '32bd468e-516a-11ec-bf63-0242ac130001',
  //   exam: 'trails'
  // },
  // {
  //   path: 'trails-blue',
  //   code: '32bd468e-516a-11ec-bf63-0242ac130002',
  //   exam: 'trails'
  // },
  // {
  //   path: 'go-no-go',
  //   code: '32bd468e-516a-11ec-bf63-0242ac130004',
  //   exam: 'go-no-go'
  // },
  // {
  //   path: 'paired-association',
  //   code: '32bd468e-516a-11ec-bf63-0242ac130006',
  //   exam: 'paired-association'
  // },
  // {
  //   path: 'processing-speed',
  //   code: '32bd468e-516a-11ec-bf63-0242ac130007',
  //   exam: 'processing-speed'
  // },
  // {
  //   path: 'word-recognition',
  //   code: '32bd468e-516a-11ec-bf63-0242ac130010',
  //   exam: 'word-recognition'
  // }
]
